/// <amd-module name="VSS/Fabric/FabricThemeUtil" />
import { IPalette, ISemanticColors, loadTheme } from "OfficeFabric/Styling";
import { expandThemeableProperties, ThemeData } from "VSS/Core/Util/Theming";

export function setFabricTheme(themeData: ThemeData): void {
    // Convert the TFS theme into the appropriate OfficeFabric Theme.
    const palette: Partial<IPalette> = {};

    // Build the primary color part of the palette.
    palette.themePrimary = expandThemeableProperties("var(--communication-background)", themeData);
    palette.themeLighterAlt = expandThemeableProperties("rgba(var(--palette-primary-tint-40), 1)", themeData);
    palette.themeLighter = expandThemeableProperties("rgba(var(--palette-primary-tint-30), 1)", themeData);
    palette.themeLight = expandThemeableProperties("rgba(var(--palette-primary-tint-20), 1)", themeData);
    palette.themeTertiary = expandThemeableProperties("rgba(var(--palette-primary-tint-10), 1)", themeData);
    palette.themeDarkAlt = expandThemeableProperties("rgba(var(--palette-primary-shade-10), 1)", themeData);
    palette.themeDark = expandThemeableProperties("rgba(var(--palette-primary-shade-20), 1)", themeData);
    palette.themeDarker = expandThemeableProperties("rgba(var(--palette-primary-shade-30), 1)", themeData);

    // Build the neutral color part of the palette.
    palette.neutralLighterAlt = expandThemeableProperties("rgba(var(--palette-neutral-2), 1)", themeData);
    palette.neutralLighter = expandThemeableProperties("rgba(var(--palette-neutral-4), 1)", themeData);
    palette.neutralLight = expandThemeableProperties("rgba(var(--palette-neutral-8), 1)", themeData);
    palette.neutralQuaternaryAlt = expandThemeableProperties("rgba(var(--palette-neutral-10), 1)", themeData);
    palette.neutralQuaternary = expandThemeableProperties("rgba(var(--palette-neutral-10), 1)", themeData); /* Slightly lighter in Fabric */
    palette.neutralTertiaryAlt = expandThemeableProperties("rgba(var(--palette-neutral-20), 1)", themeData);
    palette.neutralTertiary = expandThemeableProperties("rgba(var(--palette-neutral-30), 1)", themeData);
    palette.neutralSecondary = expandThemeableProperties("rgba(var(--palette-neutral-60), 1)", themeData);
    palette.neutralPrimaryAlt = expandThemeableProperties("rgba(var(--palette-neutral-80), 1)", themeData); /* Slightly darker in Fabric */
    palette.neutralPrimary = expandThemeableProperties("rgba(var(--palette-neutral-80), 1)", themeData);
    palette.neutralDark = expandThemeableProperties("rgba(var(--palette-neutral-100), 1)", themeData);

    // Other general colors.
    palette.black = expandThemeableProperties("rgba(var(--palette-neutral-100), 1)", themeData);
    palette.white = expandThemeableProperties("rgba(var(--palette-neutral-0), 1)", themeData);

    const semanticColors: Partial<ISemanticColors> = {};
    semanticColors.listText = expandThemeableProperties("var(--text-primary-color)", themeData);
    semanticColors.link = expandThemeableProperties("var(--communication-foreground)", themeData);
    semanticColors.errorText = expandThemeableProperties("rgba(var(--palette-accent1-dark), 1)", themeData);
    semanticColors.errorBackground = expandThemeableProperties("rgba(var(--palette-accent1-light), 1)", themeData);
    semanticColors.warningHighlight = expandThemeableProperties("rgba(var(--palette-accent3-dark), 1)", themeData);
    semanticColors.warningBackground = expandThemeableProperties("rgba(var(--palette-accent3-light), 1)", themeData);
    semanticColors.warningText = expandThemeableProperties("var(--text-primary-color)", themeData);
    semanticColors.menuItemBackgroundHovered = expandThemeableProperties("var(--component-menu-selected-item-background)", themeData);

    // Load the theme into the office fabric theme system.
    loadTheme({ palette: palette, semanticColors: semanticColors });
}
